import { clone, IComponent, IOperator, IControl, IComponentType, IAction, IOutput, ISharedJourneyItem, IRedirectCandidate, IOption } from '../../helpers/';
import { IDropdownOption } from 'office-ui-fabric-react';
import types from '../types';

interface ICacheState {
	fieldTypes: IDropdownOption[];
	actionTypes: IDropdownOption[];
	// entityFields: IDropdownOption[];
	actionTemplates: { [name: string]: IAction };
	componentTemplates: IComponent[];
	componentTypes: IComponentType[];
	operatorTypes: string[];
	operators: IOperator[];
	controlTypes: IDropdownOption[];
	outputTypes: IOutput[];
	controlTemplates: any;
	urls: any;
	loading: boolean;
	sharedJourneys: ISharedJourneyItem[];
	journeyTypes: IDropdownOption[];
	redirectCandidateTypeOptions: IOption[],
	redirectCandidateTemplates: { [type: number]: IRedirectCandidate }
}

const initialState: ICacheState = {
	fieldTypes: [],
	actionTypes: [],
	// entityFields: [],
	actionTemplates: {},
	componentTemplates: [],
	componentTypes: [],
	operatorTypes: [],
	operators: [],
	controlTypes: [],
	controlTemplates: {},
	outputTypes: [],
	urls: {},
	loading: true,
	sharedJourneys: [],
	journeyTypes: [{
		key: 0,
		text: "Normal Journey",
		index: 0,
		selected: false
	},
	{
		key: 1,
		text: "Shared Journey",
		index: 1,
		selected: false
	},
	{
		key: 2,
		text: "Triage Journey",
		index: 2,
		selected: false
	},
	{
		key: 3,
		text: "Page Journey",
		index: 3,
		selected: false
	}
	],
	redirectCandidateTypeOptions: [],
	redirectCandidateTemplates: {}
};

const cacheReducer = function (state: ICacheState = initialState, action) {

	let stateClone: ICacheState = clone(state);

	switch (action.type) {

		case types.SET_FIELD_TYPES:
			stateClone = setFieldTypes(stateClone, action.fieldTypes);
			break;

		// case types.SET_ENTITY_FIELDS:
		// 	stateClone = setEntityFields(stateClone, action.entityFields);
		// 	break;

		case types.SET_ACTION_TYPES:
			stateClone = setActionTypes(stateClone, action.actionTypes);
			break;

		case types.SET_JOURNEY_TYPES:
			stateClone = setJourneyTypes(stateClone, action.journeyTypes);
			break;

		case types.ADD_ACTION_TEMPLATE:
			stateClone = addActionTemplate(stateClone, action.actionTemplate);
			break;

		case types.SET_COMPONENT_TEMPLATES:
			stateClone = setComponentTemplates(stateClone, action.componentTemplates);
			break;

		case types.SET_COMPONENT_TYPES:
			stateClone = setComponentTypes(stateClone, action.componentTypes);
			break;

		case types.SET_OPERATORS_TYPES:
			stateClone = updateOperatorTypes(stateClone, action.operatorTypes);
			break;

		case types.SET_OPERATORS:
			stateClone = setOperators(stateClone, action.operators);
			break;

		case types.SET_CONTROL_TYPES:
			stateClone = setControlTypes(stateClone, action.controlTypes);
			break;

		case types.SET_OUTPUT_TYPES:
			stateClone = setOutputTypes(stateClone, action.templates);
			break;

		case types.ADD_CONTROL_TEMPLATE:
			stateClone = addControlTemplate(stateClone, action.key, action.controlTemplate);
			break;

		case types.SET_URLS:
			stateClone = setUrls(stateClone, action.urls);
			break;

		// case types.SET_ACTIONS:
		// 	stateClone = setActions(stateClone, action.actions);
		// 	break;

		case types.SET_LOADING:
			stateClone = setLoading(stateClone, action.loading);
			break;

		case types.UPDATE_SHARED_JOURNEYS:
			stateClone = updateSharedJourneys(stateClone, action.sharedJourneys);
			break;

		case types.SET_REDIRECT_CANDIDATE_TYPE_OPTIONS:
			stateClone = setRedirectCandidateTypeOptions(stateClone, action.candidateTypeOptions);
			break;

		case types.ADD_REDIRECT_CANDIDATE_TEMPLATE:
			stateClone = addRedirectCandidateTemplate(stateClone, action.candidateType, action.candidateTemplate);
			break;

		default:
			break;
	}

	return stateClone;
};

let setRedirectCandidateTypeOptions = (state: ICacheState, candidateTypeOptions: IOption[]): ICacheState => {
	state.redirectCandidateTypeOptions = candidateTypeOptions;
	return state;
}

let addRedirectCandidateTemplate = (state: ICacheState, candidateType: number, candidateTemplate: IRedirectCandidate): ICacheState => {

	state.redirectCandidateTemplates[candidateType] = candidateTemplate;
	return state;
}

let setComponentTemplates = (state: ICacheState, componentTemplates: IComponent[]): ICacheState => {
	state.componentTemplates = componentTemplates;
	return state;
};

let setComponentTypes = (state: ICacheState, componentTypes: IComponentType[]): ICacheState => {
	state.componentTypes = componentTypes;
	return state;
};

let updateOperatorTypes = (state: ICacheState, operatorTypes: string[]): ICacheState => {
	state.operatorTypes = operatorTypes;
	return state;
};

let setOperators = (state: ICacheState, operators: IOperator[]): ICacheState => {
	state.operators = clone(operators);
	return state;
};

let setControlTypes = (state: ICacheState, controlTypes: IDropdownOption[]): ICacheState => {
	state.controlTypes = controlTypes;
	return state;
};

let setJourneyTypes = (state: ICacheState, journeyTypes: IDropdownOption[]): ICacheState => {
	state.journeyTypes = journeyTypes;
	return state;
};

let addControlTemplate = (state: ICacheState, key: string, controlTemplate: IControl): ICacheState => {
	state.controlTemplates[key] = controlTemplate;
	return state;
};

let setUrls = (state: ICacheState, urls: any): ICacheState => {
	state.urls = {};
	let baseUrl = urls['base'];
	for (let key in urls) {
		if (key !== 'base') {
			state.urls[key] = baseUrl + urls[key];
		}
	}

	return state;
};

let setFieldTypes = (state: ICacheState, fieldTypes: IDropdownOption[]): ICacheState => {
	state.fieldTypes = fieldTypes;
	return state;
};

// let setEntityFields = (state: ICacheState, entityFields: IDropdownOption[]): ICacheState => {
// 	state.entityFields = entityFields;
// 	return state;
// };

let setActionTypes = (state: ICacheState, actionTypes: IDropdownOption[]): ICacheState => {
	state.actionTypes = actionTypes;
	return state;
};

let addActionTemplate = (state: ICacheState, actionTemplate: IAction): ICacheState => {
	state.actionTemplates[actionTemplate.ActionType.NameType] = actionTemplate;
	return state;
};

// const setActions = (state: ICacheState, actions: IAction[]): ICacheState => {
// 	state.actionTemplates = actions;
// 	return state;
// };

const setOutputTypes = (state: ICacheState, outputs: IOutput[]): ICacheState => {
	state.outputTypes = outputs;
	return state;
};

const setLoading = (state: ICacheState, loading: boolean): ICacheState => {
	state.loading = loading;
	return state;
};

const updateSharedJourneys = (state: ICacheState, sharedJourneys: any) => {

	let newSharedJourneyItemArray: ISharedJourneyItem[] = [];

	for (let journeyId in sharedJourneys) {
		newSharedJourneyItemArray.push({
			journeyId: journeyId,
			journeyName: sharedJourneys[journeyId]
		});
		newSharedJourneyItemArray.sort((a, b) => {

			if (a.journeyName < b.journeyName) {
				return -1;
			}

			if (a.journeyName > b.journeyName) {
				return 1;
			}

			return 0;

		});
	}

	state.sharedJourneys = newSharedJourneyItemArray;

	return state;

};

export default cacheReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/cache.ts